"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
const columnCustomCell = (arg) => {
    const columnCell = (props) => {
        return ((0, jsx_runtime_1.jsx)(kendo_react_grid_1.GridColumn, Object.assign({ cell: arg.cellRender, width: arg.width || 'auto', title: arg.title || '' }, props)));
    };
    return columnCell;
};
exports.default = columnCustomCell;
